import {api} from "../../api";
import {handleResponse, RequestOptions} from "../types";

const getAgentStatReportSettings = () => {
  return fetch(`/settings/agentStatReport.json`)
    //.then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
}

export const reportsSettingsService = {
  getAgentStatReportSettings
};
